import type { SupplierReevaluationState } from './types';

const UPCOMING_DAYS = 30;

function startOfDay(date: Date): Date {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

function diffInDays(target: Date, now: Date): number {
  const start = startOfDay(now);
  const end = startOfDay(target);
  return Math.round((end.getTime() - start.getTime()) / 86_400_000);
}

export function resolveReevaluationState(
  nextReevaluationAt: string | null | undefined,
  now: Date = new Date(),
): SupplierReevaluationState {
  if (!nextReevaluationAt) return null;
  const due = new Date(nextReevaluationAt);
  if (Number.isNaN(due.getTime())) return null;

  const daysUntilDue = diffInDays(due, now);
  if (daysUntilDue < 0) return 'overdue';
  if (daysUntilDue <= UPCOMING_DAYS) return 'upcoming';
  return null;
}

export const REEVALUATION_STATE_LABEL: Record<Exclude<SupplierReevaluationState, null>, string> = {
  overdue: 'Vencida',
  upcoming: 'Próxima',
};

export const REEVALUATION_STATE_CLASS: Record<Exclude<SupplierReevaluationState, null>, string> = {
  overdue: 'bg-red-100 text-red-800',
  upcoming: 'bg-amber-100 text-amber-800',
};
